import { Box, useMediaQuery } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { motion, AnimatePresence } from 'motion/react'
import RightArrow from '../../images/RightArrow.svg'
import { searchBarVariants } from '../../utils/animation'
import SearchBarV2 from './SearchBarV2'

const SearchBarToggle = ({
  searchPlaceholder, actionToDispatch,
  setExpandedState, expandedState, customStyle, sendQueryAsObject, actionProps,
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  const handleSearchBarToggle = () => {
    setExpandedState(!expandedState)
  }
  const handleSearchBarClose = () => {
    setExpandedState(false)
  }
  return (
    <Box sx={[expandedState && styles.searchContainerExpanded, customStyle]}>
      <AnimatePresence mode="wait">
        {((isXsScreen && expandedState) || !isXsScreen) ? (
          <Box
            key="searchBar"
            component={motion.div}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={isXsScreen && searchBarVariants}
          >
            <SearchBarV2
              ignoreIconClick
              searchPlaceholder={searchPlaceholder}
              actionToDispatch={actionToDispatch}
              sendQueryAsObject={sendQueryAsObject}
              actionProps={actionProps}
              customIcon={
                isXsScreen && (
                  <Box component={motion.div}>
                    <Box
                      component="img"
                      src={RightArrow}
                      alt="Search Button"
                      onClick={handleSearchBarClose}
                      sx={styles.arrowIcon}
                    />
                  </Box>
                )
              }
            />
          </Box>
        ) : (
          <Box sx={[styles.searchIcon, customStyle]} className="search-icon" onClick={handleSearchBarToggle}>
            <SearchIcon />
          </Box>
        )}
      </AnimatePresence>
    </Box>
  )
}

const styles = {
  searchIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '25px',
    height: '25px',
    cursor: 'pointer',
    borderRadius: '10px',
    backgroundColor: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    marginRight: '20px',
    svg: {
      fontSize: '20px',
      color: '#92929D',
    },
  },
  searchContainerExpanded: {
    width: '100%',
  },
}
export default SearchBarToggle
